module.exports = __webpack_public_path__ + "img/puberty-decal-17.c3fef1da.png";